import { Icon } from "@iconify/react";
import React from "react";
import { MotionDiv } from "@/components/animations/MotionDivWrapper"; 
import VendureLogo from "@/assets/svg/Vendure.svg";
import ApolloClientLogo from "@/assets/svg/Apollo.svg";
import JotaiLogo from "@/assets/svg/jotai.svg";
import ZustandLogo from "@/assets/svg/zustand.svg";

interface TechBadgeProps {
  name: string;
  className?: string;
  idx: number;
}

const techIcons: Record<string, string> = {
  "React": "logos:react",
  "React.js": "logos:react",
  "Next.js": "logos:nextjs-icon",
  "Remix.js": "logos:remix-icon",
  "NestJS": "logos:nestjs",
  "Node.js": "logos:nodejs-icon",
  "Express.js": "devicon:express",
  "MongoDB": "logos:mongodb-icon",
  "GraphQL": "logos:graphql",
  "Redux": "logos:redux",
  "TypeScript": "logos:typescript-icon",
  "Tailwind CSS": "logos:tailwindcss-icon",
  "AWS": "logos:aws",
  "Stripe": "logos:stripe",
  "PostgreSQL": "logos:postgresql",
};

const customIcons: Record<string, string> = {
  Vendure: VendureLogo,
  "Apollo Client": ApolloClientLogo,
  Jotai: JotaiLogo,
  Zustand: ZustandLogo,
};

const TechBadge: React.FC<TechBadgeProps> = ({ name, className,idx }) => {
  const isCustom = Object.keys(customIcons).includes(name);
  const icon = techIcons[name];

  return (
    <MotionDiv className={className} direction="up" delay={0.05 * idx}>
  <div
    className={`flex items-center gap-1.5 bg-[#2A2A2A] border border-[#8A8F98]/30 text-white px-2 py-0.5 rounded-full text-[10px] transition-all duration-200 hover:bg-[#3A3A3A] hover:scale-105 cursor-default`}
    title={name}
  >
    {isCustom ? (
      <img
        src={customIcons[name]}
        alt={name}
        className="w-3 h-3 object-contain"
      />
    ) : (
      <Icon icon={icon || "mdi:code-tags"} width={14} height={14} />
    )}
    <span className="text-[12px]">{name}</span>
  </div>
</MotionDiv>

  );
};

export default TechBadge;
